module.exports = __webpack_public_path__ + "static/media/saomagouAPPruanjian.3c7ff048.png";